import React, { useState, useEffect, useRef } from "react";
import Sales from ".";
import { withFirebase } from "../../../firebase";

const SalesContainer = (props) => {
	const [sales, setSales] = useState([]);
	const [preloader, setPreloader] = useState(true);
	const [isNewAdmin, setIsNewAdmin] = useState(false);
	const [salesKey, setSalesKey] = useState("salesSystem"); // 'salesSystem' | 'saleSystem'
	const activeRefPath = useRef(null);

	useEffect(() => {
		// Проверка прав администратора и установка значения
		const adminPermission = JSON.parse(localStorage.getItem("adminPermission"));
		const newAdminStatus = adminPermission?.newAdmin || false;
		setIsNewAdmin(newAdminStatus);

		// Функция для получения данных о продажах
		const getSales = () => {
			const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
			const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));

			// Базовый путь без ключа
			const basePath = isNewAdmin
				? `web/settings/city/${currentCity}/brands/${currentBrand}/loyaltySettings`
				: `web/settings/city/${currentCity}/loyaltySettings`;

			// Сначала пробуем salesSystem, если нет — смотрим saleSystem
			const primaryRef = props.firebase.bd.ref(`${basePath}/salesSystem`);
			const fallbackRef = props.firebase.bd.ref(`${basePath}/saleSystem`);

			primaryRef.once("value").then((snap) => {
				if (snap.exists()) {
					activeRefPath.current = `${basePath}/salesSystem`;
					setSalesKey("salesSystem");
					primaryRef.on("value", (snapshot) => {
						let salesData = snapshot.val();
						salesData = salesData ? salesData : [];
						setSales(salesData);
						setPreloader(false);
					});
				} else {
					fallbackRef.once("value").then((fsnap) => {
						if (fsnap.exists()) {
							activeRefPath.current = `${basePath}/saleSystem`;
							setSalesKey("saleSystem");
							fallbackRef.on("value", (snapshot) => {
								let salesData = snapshot.val();
								salesData = salesData ? salesData : [];
								setSales(salesData);
								setPreloader(false);
							});
						} else {
							// Ничего нет — работаем с новым ключом salesSystem
							activeRefPath.current = `${basePath}/salesSystem`;
							setSalesKey("salesSystem");
							setSales([]);
							setPreloader(false);
						}
					});
				}
			});
		};

		getSales();

		return () => {
			if (activeRefPath.current) {
				props.firebase.bd.ref(activeRefPath.current).off();
			} else {
				props.firebase.bd.ref().off();
			}
		};
	}, [props.firebase, isNewAdmin]);

	const updateSaleStatus = (index, isActive) => {
		const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
		const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));

		const basePath = isNewAdmin
			? `web/settings/city/${currentCity}/brands/${currentBrand}/loyaltySettings`
			: `web/settings/city/${currentCity}/loyaltySettings`;
		const refPath = `${basePath}/${salesKey}`;

		const updatedSales = sales.map((sale, i) =>
			i === index ? { ...sale, isActive } : sale
		);

		// Обновляем данные в Firebase
		props.firebase.bd.ref(refPath).set(updatedSales, (error) => {
			if (error) {
				console.error("Ошибка при обновлении данных:", error);
			} else {
				setSales(updatedSales);
			}
		});
	};

	return (
		<div>
			{preloader ? (
				<></>
			) : (
				<Sales sales={sales} updateSaleStatus={updateSaleStatus} />
			)}
		</div>
	);
};

export default withFirebase(SalesContainer);
